import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getAllConfigPropertiesForBrandAndInfluencer = (payload) => ({
    type: actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const getAllConfigPropertiesForBrandAndInfluencerSuccess = (payload) => ({
    type: actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getAllConfigPropertiesForBrandAndInfluencerFailure = (payload) => ({
    type: actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getAllConfigPropertiesForBrandAndInfluencerReset = () => ({
    type: actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getAllConfigPropertiesForBrandAndInfluencerResetAll = () => ({
    type: actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET_ALL,
});
